var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C6.65685 0 8 1.34315 8 3V5H9C9.55229 5 10 5.44772 10 6V11C10 11.5523 9.55229 12 9 12H1C0.447715 12 0 11.5523 0 11V6C0 5.44772 0.447715 5 1 5H2V3C2 1.34315 3.34315 0 5 0ZM5 7C4.44772 7 4 7.44772 4 8C4 8.34813 4.17789 8.65471 4.44773 8.83379L4.55306 8.89481L4 10H6L5.44796 8.8943C5.77533 8.73 6 8.39124 6 8C6 7.44772 5.55228 7 5 7ZM5 2C4.44772 2 4 2.44772 4 3V5H6V3C6 2.44772 5.55228 2 5 2Z",
    fill: "#5BA1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure);
export default __webpack_public_path__ + "static/media/icon-secure.5a305c59.svg";
export { ForwardRef as ReactComponent };